import z from "zod";

export const TIMEZONE_COOKIE_NAME = 'tuic-timezone';

export const timeZoneCookieSchema = z.object({
  iana: z.string(), // IANA time zone name, e.g., "Europe/Berlin"
  offset: z.number(), // Offset in minutes
});

export type TimeZoneCookie = z.output<typeof timeZoneCookieSchema>;

export const toTimeZoneCookie = (data: TimeZoneCookie): string => {
  return encodeURIComponent(JSON.stringify(data));
};

export const fromTimeZoneCookie = (data: unknown): TimeZoneCookie | undefined => {
  if (!data || typeof data !== 'string') {
    return undefined;
  }

  try {
    const parsed = JSON.parse(decodeURIComponent(data));

    return timeZoneCookieSchema.parse(parsed);
  } catch {
    return undefined;
  }
};

